var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddReceipt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2352 3.48047H4.56852C3.64805 3.48047 2.90186 4.22666 2.90186 5.14714V16.8138C2.90186 17.7343 3.64805 18.4805 4.56852 18.4805H16.2352C17.1557 18.4805 17.9019 17.7343 17.9019 16.8138V5.14714C17.9019 4.22666 17.1557 3.48047 16.2352 3.48047Z",
    stroke: "#5B5959",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4019 7.64844V14.3151",
    stroke: "#5B5959",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0686 10.9805H13.7353",
    stroke: "#5B5959",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddReceipt);
export default __webpack_public_path__ + "static/media/addReceipt.3afc46824444025c7e39f732a05d46e9.svg";
export { ForwardRef as ReactComponent };